import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class Regiao implements Construtor<Regiao> {

  public idRegiao: number;
  public descricaoRegiao: string;
  public selecionado: boolean;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof Regiao) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  get obterIdRegiao(): number {
    return this.idRegiao;
  }

  set IdRegiao(idRegiao: any) {
    this.idRegiao = idRegiao;
  }

  get obterDescricaoRegiao(): string {
    return this.descricaoRegiao.slice(0);
  }

  set DescricaoRegiao(descricaoRegiao: any) {
    this.descricaoRegiao = StringValidacao.copiarStringValida(descricaoRegiao);
  }

  copyObject(regiao: Regiao): void {

    this.idRegiao = regiao.obterIdRegiao;
    this.descricaoRegiao = regiao.obterDescricaoRegiao;
  }

  parseFromJson(regiao: any): void {

    this.IdRegiao = regiao.idRegiao;
    this.DescricaoRegiao = regiao.descricaoRegiao;

  }

  modeloCompleto(): boolean {
    return this.descricaoRegiao !== undefined;
  }

  getNewInstance(object?: any): Regiao {
    return new Regiao(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/regiao.ts